module.exports = __webpack_public_path__ + "static/media/8D.3ce263b6.svg";